import { render, staticRenderFns } from "./info.vue?vue&type=template&id=e0fbc7ca&scoped=true"
import script from "./info.vue?vue&type=script&lang=js"
export * from "./info.vue?vue&type=script&lang=js"
import style0 from "./info.vue?vue&type=style&index=0&id=e0fbc7ca&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0fbc7ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e0fbc7ca')) {
      api.createRecord('e0fbc7ca', component.options)
    } else {
      api.reload('e0fbc7ca', component.options)
    }
    module.hot.accept("./info.vue?vue&type=template&id=e0fbc7ca&scoped=true", function () {
      api.rerender('e0fbc7ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/info/info.vue"
export default component.exports